import {
    GET_POTENTIAL_TAKERS,
    GET_POTENTIAL_TAKERS_FAILURE,
    GET_POTENTIAL_TAKERS_SUCCESS,
    GET_SHIFTS,
    GET_SHIFTS_FAILURE,
    GET_SHIFTS_SUCCESS,
    GET_MY_SHIFT,
    GET_MY_SHIFT_FAILURE,
    GET_MY_SHIFT_SUCCESS,
    CLEAR_SHIFTS,
} from '../constants';

export default class ShiftSchedulerAction {
    static GetPotentialTakers(payload, cb) {
        return {
            type: GET_POTENTIAL_TAKERS,
            payload,
            cb,
        };
    }

    static GetPotentialTakersSuccess(payload) {
        return {
            type: GET_POTENTIAL_TAKERS_SUCCESS,
            payload,
        };
    }

    static GetPotentialTakersFailure() {
        return {
            type: GET_POTENTIAL_TAKERS_FAILURE,
        };
    }

    static GetShifts(payload, cb) {
        return {
            type: GET_SHIFTS,
            payload,
            cb,
        };
    }

    static GetShiftsSuccess(payload) {
        return {
            type: GET_SHIFTS_SUCCESS,
            payload,
        };
    }

    static GetShiftsFailure(isSubscriptionError) {
        return {
            type: GET_SHIFTS_FAILURE,
            payload: isSubscriptionError,
        };
    }

    static ClearShifts() { 
        return{
            type: CLEAR_SHIFTS
        }
    }

    // New GetMyShift Action
    static GetMyShift(payload, cb) {
        return {
            type: GET_MY_SHIFT,
            payload,
            cb,
        };
    }

    static GetMyShiftSuccess(payload) {
        return {
            type: GET_MY_SHIFT_SUCCESS,
            payload,
        };
    }

    static GetMyShiftFailure(isSubscriptionError) {
        return {
            type: GET_MY_SHIFT_FAILURE,
            payload: isSubscriptionError,
        };
    }
}
